import { SensorId } from "./types";
import { getLocale, i18n } from "./i18n";
import { translations } from "./translations";

/**
 * Class with helper functions to get sensor labels and to translate raw values into human readable ones
 */
export class sensorInfo {
  static getLabel(sensorId: number, locale?: string) {
    const currentLocale = getLocale(locale);
    const labels = translations[currentLocale].sensorLabels;
    return labels[String(sensorId)] || sensorId.toString();
  }

  static getShortLabel(sensorId: number, locale?: string) {
    const currentLocale = getLocale(locale);
    const labels = translations[currentLocale].sensorLabelsShort;
    return labels[String(sensorId)] || sensorId.toString();
  }

  static getValue(
    sensorValue: string | number,
    sensorId: SensorId,
    locale?: string
  ) {
    const currentLocale = getLocale(locale);

    if ([10, 524].includes(sensorId)) {
      return sensorValue === 1
        ? i18n.t("ui:status.healthy", { lng: currentLocale })
        : i18n.t("ui:status.unhealthy", { lng: currentLocale });
    }

    if (sensorId === 23) {
      const numValue = Number(sensorValue);
      if (
        isNaN(numValue) ||
        sensorValue === undefined ||
        sensorValue === null
      ) {
        return "-";
      }
      return new Intl.NumberFormat(translations[currentLocale].intlLocale, {
        style: "percent",
      }).format(numValue / 100);
    }

    const values = translations[currentLocale].sensorValues;
    return values[String(sensorValue)] || sensorValue;
  }
}
